import React, { FunctionComponent, useEffect } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { connect } from 'react-redux'

import { Login } from '../../components/pages/old'

import { State } from '../../reducers'
import { loginUser, getUserFromSession } from '../../actions/user'
import { useStoredUser } from '../../utils/sorcery'

import { UserStore } from '../../typings/stores/UserStore'

interface LoginContainerProps extends RouteComponentProps {
  user?: UserStore
  error?: string
  loginUser(username: string, password: string): void
  getUserFromSession(): void
}

const LoginContainer: FunctionComponent<LoginContainerProps> = ({
  history,
  user,
  error,
  loginUser,
  getUserFromSession,
}) => {
  const sessionChecked = useStoredUser(getUserFromSession, user)

  useEffect(() => {
    // If user exists in memory, is logged in, and has approved the current TOS,
    // then redirect to main app
    if (sessionChecked && !user.loggingIn && user.loggedIn) {
      history.push('/app')
    }
  }, [sessionChecked, user.loggingIn, user.loggedIn, history])

  return <Login user={user} submitLogin={loginUser} error={error} />
}

const mapStateToProps = (state: State) => ({
  user: state.user,
  error: state.user.error,
})

const mapDispatchToProps = dispatch => ({
  loginUser: (u: string, p: string) => dispatch(loginUser(u, p)),
  getUserFromSession: () => dispatch(getUserFromSession()),
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LoginContainer)
)
